export default function Shop() {
  return <h1>Get your own shop in Heja</h1>
}
